<div class="export-container">
  <form [formGroup]="form" novalidate>
    <div class="dataset-main-container">
      <div class="dataset-label">
        <wm-common-text
          [data]="{
            text: 'Choose your dataset'
          }"
        ></wm-common-text>
      </div>

      <div class="export-dataset-dropdown">
        <wm-common-dropdown
          [data]="{
            placeholder: 'SELECT DATASET',
            options: exportOptions,
          }"
          id="selDS"
          name="selDS"
          [formControl]="selDS"
          (change)="switchDataSet()"
        >
        </wm-common-dropdown>
      </div>

      <div class="content-center">
        <div *ngIf="dataSetId && exportOptions.length > 0">
          <wm-dataset-input
            [dataSetId]="dataSetId"
            [form]="form"
            (filterFormChanged)="filterFormChanged($event)"
            (filtersChanged)="dataSetFiltersChanged($event)"
            (dataSetLoaded)="dataSetLoaded($event)"
            (filterParamsChanged)="dataSetParamsChanged($event)"
            (columnsChanged)="dataSetColumnsChanged($event)"
            [shapefileValidationCriteria]="shapefileValidationCriteria"
            [staffFilterBuilder]="true"
          ></wm-dataset-input>
        </div>

        <router-outlet name="overlay"></router-outlet>

        <div>
          @if (dataSetId) {
          <app-reports-table-header
            [id]="id"
            [title]="title"
            [params]="dsParams"
            [currentFilters]="dsFilters"
            [currentColumnOptions]="exportOptions"
            (exportExcel)="exportExcel()"
            (exportCsv)="exportCsv()"
          ></app-reports-table-header>

          <ng-container *ngIf="dataSetId || (exportId && exportOptions)">
            <div class="row mt-2 ml-2 p-0">
              <div class="col m-0 p-0">
                <div [hidden]="!exporting">
                  <div class="spinner-border"></div>
                  Exporting...
                </div>
                <div [hidden]="!showDownloadLink">
                  <div>
                    <a
                      class="download-link"
                      [attr.href]="sanitize(link.href)"
                      [attr.download]="link.download"
                    >
                      Download {{ link.download }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          }
        </div>
      </div>
    </div>
  </form>
</div>
